// config.js
module.exports = {
  CONSTANT: {
    AWS_LAMBDA_DOMAIN: 'https://djhxn489y7.execute-api.ap-northeast-1.amazonaws.com/Stage/',
  },
};
